module.exports = __webpack_public_path__ + "a45a305bd4b0e14fe6e1cb5ea9b02cc0.svg";